export default __webpack_public_path__ + "static/media/spinner.17b2cd24.svg";